class Paragraphe {
    type = ''; // [imager, vitrine] 
    title = '';
    body = '';
    color = ''; // [white, grey]
    link = '';
    linkLabel = '';
    linkClass = '';

    constructor(type, title) {
        this.type = type;
        this.title = title
        this.color = 'white';
    }
}

export default Paragraphe;